import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DbService } from 'src/app/core/services/db.service';

@Component({
  selector: 'app-manager-alarm-detail',
  templateUrl: './manager-alarm-detail.component.html',
  styleUrls: ['./manager-alarm-detail.component.scss'],
})
export class ManagerAlarmDetailComponent implements OnInit {
  alarms: Array<any> = [];
  isReady: boolean = false;
  constructor(private db: DbService, private modalCtrl: NgbModal) {}

  ngOnInit(): void {
    this.getAlarm();
  }

  async getAlarm(): Promise<void | boolean> {
    const data = await this.db.getAlarmList();
    if (data.status == 'success') {
      this.alarms = data.data.sort(function (a, b) {
        return new Date(b.datecreated).getTime() - new Date(a.datecreated).getTime();
      });
      this.isReady = true;
    }
  }

  dismiss(): void {
    this.modalCtrl.dismissAll();
  }
}
